module.exports = __webpack_public_path__ + "static/media/success_duplicate.6049f7cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/success_duplicate.png
// module id = 505
// module chunks = 0